export default function XML_Syntax() {
  return (
    <div>
      <h1>XML_Syntax</h1>
      <p>This is the XML_Syntax component.</p>
    </div>
  );
}